export const API_GATEWAY_ENDPOINT = "https://fdqxl5f8jf.execute-api.us-east-1.amazonaws.com/dev/"